import { CAMPAIGN_ELASTICSEARCH_RECEIVE } from '../actions';

const initialCounters = {
  category: undefined,
  brand: undefined,
  store: undefined,
  prices: undefined,
  store_rating: undefined,
  product_rating: undefined,
};

export default (
  // eslint-disable-next-line default-param-last
  state = {
    popularCategories: null,
    categoryTree: null,
    campaigns: null,
    popularCampaignFilterPaths: null,

    hits: [],
    total: 0,

    counters: initialCounters,

    stats: {
      max_price: 0,
      min_price: 0,
    },

    filters: {
      category: {
        query: '',
      },
      brand: {
        query: '',
      },
      store: {
        query: '',
      },
    },
  },
  action
) => {
  switch (action.type) {
    /**
      NOTE: All config is dispatched, any data returned will be sent
      down to the browser. Make sure no secrets is leaking!
    * */
    case '__DANGEROUS_CONFIG_RECEIVE': {
      const socialNetworks = Object.keys(
        action.market.socialNetworks || {}
      ).reduce(
        (links, network) => ({
          ...links,
          [network]: action.market.socialNetworks[network].link,
        }),
        {}
      );
      return {
        ...state,
        translation: action.market.translation, // TODO: Add this to translate context instead
        timezone: action.market.timezone,
        legacyUrls: {
          ...action.market.url.legacy,
          ...socialNetworks,
        },
        base: action.market.url.campaigns,
        popularCampaignFilterPaths: action.market.popularCampaignFilterPaths,
      };
    }
    case CAMPAIGN_ELASTICSEARCH_RECEIVE: {
      const newState = {
        ...state,
        hits: action.data.hits.hits,
        total: action.data.hits.total,
      };
      if (action.data.aggregations) {
        Object.keys(action.data.aggregations).forEach(key => {
          if (newState.counters[key] && state.counters[key]) {
            newState.counters[key] = action.data.aggregations[
              key
            ].buckets.reduce(
              (all, curr) =>
                Object.assign(all, {
                  [curr.key]: curr.doc_count,
                }),
              {}
            );
          }
          if (newState.stats[key] && state.stats[key]) {
            newState.stats[key] = action.data.aggregations[key].value;
          }
        });
      }

      return newState;
    }
    default:
    // Do nothing
  }
  return state;
};
